export var game = {
  namespaced: true,
  state: {
    selectGameId: 0,
    gameList: []
  },
  mutations: {
    setSelectAppId: function setSelectAppId(state, selectAppId) {
      state.selectAppId = selectAppId;
    },
    setIsAdd: function setIsAdd(state, IsAdd) {
      state.isAdd = IsAdd;
    },
    setIsChangeAppInfo: function setIsChangeAppInfo(state, isChangeAppInfo) {
      state.isChangeAppInfo = isChangeAppInfo;
    }
  },
  actions: {},
  getters: {
    selectAppId: function selectAppId(state) {
      return state.selectAppId;
    },
    isAdd: function isAdd(state) {
      return state.isAdd;
    },
    isChangeAppInfo: function isChangeAppInfo(state) {
      return state.isChangeAppInfo;
    }
  }
};